import React from 'react';

const Credits = () => {
    return (
        <div>
            <h1>Credits:</h1>
            <p>
                some 3d models used in the filters
                <br />
                This work is based on "Medical/Surgical Mask" (https://sketchfab.com/3d-models/medicalsurgical-mask-f54ed08e35ba40d4a67fb0fce1cbf27e) by bright_moon (https://sketchfab.com/bright_moon) licensed under CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
                <br />
                "Female hairs" (https://skfb.ly/6SLQy) by miccall is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />

                
                "scary mask" (https://skfb.ly/ox7u8) by stasbelyk13 is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "Batman Mask" (https://skfb.ly/6TOuD) by David Wigforss is licensed under Creative Commons Attribution-NonCommercial (http://creativecommons.org/licenses/by-nc/4.0/).
                <br />
                "Joker Mask" (https://skfb.ly/6RvMs) by David Wigforss is licensed under Creative Commons Attribution-NonCommercial (http://creativecommons.org/licenses/by-nc/4.0/).
                <br />
                "Bunny Ears" (https://skfb.ly/on9KH) by neutralize is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "Forest Mask" (https://skfb.ly/6VRSw) by Showie is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "3D Love Emoji" (https://skfb.ly/ow7Sy) by gurami.mamaladze is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "egypt cat goddess mask" (https://skfb.ly/6WOKv) by L3eM0n is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "Masquerade Cat Mask 3" () by David Wigforss is licensed under Creative Commons Attribution-NonCommercial (http://creativecommons.org/licenses/by-nc/4.0/).
                <br />
                "Bandana Mask" (https://skfb.ly/6RxAB) by Tactical_Gamer is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "Clown 2 Mask" (https://skfb.ly/6WTp6) by David Wigforss is licensed under Creative Commons Attribution-NonCommercial (http://creativecommons.org/licenses/by-nc/4.0/).
                <br />
                "Drift Mask (3D printable)" (https://skfb.ly/6R6tF) by Mac is licensed under Creative Commons Attribution-NonCommercial (http://creativecommons.org/licenses/by-nc/4.0/).
                <br />
                "Samurai Mask" (https://skfb.ly/o7nRY) by Oren Faz is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "Welding mask" (https://skfb.ly/YzL6) by guss67 is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                <br />
                "Neon Party Glasses" (https://skfb.ly/o78oG) by Berk Gedik is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/).
                

            </p>
            <style jsx>{`
                h1,p{
                    color:black;
                    font-size:1.5rem
                }
                `}</style>
        </div>
    );
}

export default Credits;
